import { Formik } from 'formik';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import React, { RefObject } from 'react';
import { Box, Flex } from 'reflexbox';
import { Panel } from 'primereact/panel';

export interface IWeightDiffFilterContainerValue {
  minWeight: number;
  status: 'unprocess' | 'solved';
}

export class WeightDifferenceFilterContainer extends React.Component<any, any> {
  initialFormValues: IWeightDiffFilterContainerValue = {
    minWeight: 1,
    status: 'unprocess',
  };
  refFormik: RefObject<Formik> = React.createRef();

  optionStatus = [
    {
      label: 'Belum Diproses',
      value: 'unprocess',
    },
    {
      label: 'Sudah Diproses',
      value: 'solved',
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      filterCollapsed: false
    }
  }

  get formValues() {
    if (this.refFormik.current) {
      return this.refFormik.current.state.values;
    }

    return {};
  }

  setFormValues(values) {
    const currentFormValues = (this.refFormik.current) ? this.refFormik.current.state.values : {};
    const newFormValues = Object.assign({}, currentFormValues, values);
    this.refFormik.current!.setState(newFormValues);
    this.initialFormValues = newFormValues;
    return newFormValues;
  }

  render() {
    return (
      <Panel header="Filter" toggleable={true} collapsed={this.state.filterCollapsed} onToggle={(e) => this.setState({ filterCollapsed: e.value })}>
        <Formik
          ref={this.refFormik}
          initialValues={this.initialFormValues}
          onSubmit={() => { }}>
          {formikProps => (
            <Flex w={1}>
              <Box w={450}>
                <Flex column>
                  <div className="form-group">
                    <label className="col-md-5">Selisih Minimal</label>
                    <div className="col-md-7">
                      <InputText
                        name="minWeight"
                        type="number"
                        onBlur={formikProps.handleBlur}
                        onChange={formikProps.handleChange}
                        value={formikProps.values.minWeight}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-md-5">Status</label>
                    <div className="col-md-7">
                    <Dropdown
                        options={this.optionStatus}
                        onChange={formikProps.handleChange('status')}
                        value={formikProps.values.status}
                      />
                    </div>
                  </div>
                </Flex>
              </Box>
            </Flex>
          )}
        </Formik>
      </Panel>
    );
  }
}
